/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { Skeleton } from "primereact/skeleton";
import { readFromLS, urlBaseAPI } from "../../utils";

export default function ImagenAutenticada({ endpoint, alt, altura, anchoMaximo, imagenPorDefecto }) {
  const [imageSrc, setImageSrc] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargarImagen = async () => {
      setLoading(true);
      try {
        const accessToken = readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN);
        const url = urlBaseAPI() + "/" + endpoint;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        });

        if (!response.ok) {
          setError(true);
          setLoading(false);
          return;
        }

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        setImageSrc(objectUrl);
        setLoading(false);
      } catch (err) {
        console.error("Error cargando imagen:", err);
        setError(true);
        setLoading(false);
      }
    };

    cargarImagen();

    // Función de limpieza para revocar el object URL
    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [endpoint]); // eslint-disable-line react-hooks/exhaustive-deps

  if (error && imagenPorDefecto) {
    return imagenPorDefecto;
  }

  if (loading) {
    return (
      <Skeleton
        width={altura || "40px"}
        height={altura || "40px"}
        css={{
          borderRadius: "4px",
        }}
      />
    );
  }

  if (!imageSrc) {
    return null;
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      css={{
        height: altura || "40px",
        maxWidth: anchoMaximo || "120px",
        objectFit: "contain",
      }}
    />
  );
}
